import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-airdoa-white px-4">
      <p className="text-6xl md:text-8xl font-serif font-bold text-airdoa-navy/10 mb-4">404</p>
      <h1 className="text-xl md:text-2xl font-serif font-semibold text-airdoa-navy mb-2">
        ページが見つかりません
      </h1>
      <p className="text-sm text-airdoa-gray mb-8">
        お探しのページは存在しないか、移動または削除された可能性があります。
      </p>
      <Link to="/" className="btn-primary">
        トップページへ戻る
      </Link>
    </div>
  );
}
